import React from 'react';

const AvatarPicker = ({ avatarLibrary, selected, onSelect }) => {
    return (
        <div className="form-group">
      <label className="font-weight-bold">
        <i className="fa fa-image text-primary mr-2"></i> Select Avatar:
      </label>
      <div className="d-flex flex-row overflow-auto" style={{ gap: '12px', padding: '6px 0' }}>
        {avatarLibrary.map((avatar, index) => (
          <img
            key={index}
            src={avatar.avatar_url}
            alt={avatar.avatar_name || `avatar-${index}`}
            onClick={() => onSelect(avatar)}
            className={`img-thumbnail ${selected.avatar_url === avatar.avatar_url ? 'border border-primary' : ''}`}
            style={{ width: '80px', height: '80px', cursor: 'pointer' }}
          />
        ))}
      </div>
      {selected && <div className="mt-2"><strong>Selected:</strong><br /><img src={selected.avatar_url} alt="Selected Avatar" className="img-thumbnail" style={{ maxWidth: '120px' }} /></div>}
    </div>
    );
};

export default AvatarPicker;